// Claude: split from adminAPI.js — organizers + events 14-04-2026
import { api } from "./config/axiosConfig.js";
import { store } from "../redux/Store.ts";

export const AdminEventAPI = {

  // Organizer
  postOrganizer: async (register, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/admin/event-organizers/",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: register,
    });
    return response.data;
  },

  getOrganizer: async (params, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/admin/event-organizers/",
      method: "GET",
      params: params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  putOrganizer: async (id, data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/admin/event-organizers/${id}`,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    });
    return response.data;
  },

  deleteOrganizer: async (id, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/admin/event-organizers/${id}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Events
  postEvent: async (data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/admin/events/",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    });
    return response.data;
  },

  getEvent: async (params, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/admin/events/",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      params: params,
    });
    return response.data;
  },

  getEventById: async (eventID, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/admin/events/" + eventID,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  putEvent: async (id, data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/admin/events/${id}`,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    });
    return response.data;
  },

  deleteEvent: async (id, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/admin/events/${id}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

};
